import 'core-js/stable';
import 'regenerator-runtime/runtime';
import $ from 'jquery';
import { gsap } from "gsap";
import { Power4 } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import Lenis from "@studio-freight/lenis";

const lenis = new Lenis();

lenis.on("scroll", (e) => {
	// console.log(e);
});
function raf(time) {
	lenis.raf(time);
	requestAnimationFrame(raf);
}
requestAnimationFrame(raf);


gsap.registerPlugin(ScrollTrigger);
ScrollTrigger.matchMedia({
        "(min-width: 992px)": function () {
                function paralax(bottom = false, start = "-=50% top", end = "bottom") {
                        const paralaxWrapper = Array.from(
                                document.querySelectorAll(".paralaxSection")
                        ).map(function (el) {
                                const arr = Array.from(el.querySelectorAll(".paralaxEl")).map(function (
                                        item
                                ) {
                                        const tl = gsap.timeline();
                                        ScrollTrigger.create({
                                                animation: tl,
                                                trigger: el,
                                                start: start,
                                                end: end,
                                                scrub: 2,
                                                ease: "none",
                                                // markers: true,
                                        });
                                        tl.to(item, {
                                                y: (target) =>
                                                        ((bottom ? el.offsetHeight : false) || -el.offsetHeight) *
                                                        (item.dataset.ratio || 0.2),
                                        });
                                });
                        });
                }
                paralax();
        }
});

ScrollTrigger.matchMedia({
        "(max-width: 992px)": function () {
                const btnMenu = document.querySelector("#menubtn");
                const body = document.querySelector('body');
                const menuItem = gsap.utils.toArray('.header__nav li a span');
                const menuNav = document.querySelector('.header__nav');

                gsap.set(menuNav, {
                        display: "none",
                });
                gsap.set(".downloadbtn", {
                        display: "none",
                });


                let menuStatus = false
                const menuTl = gsap.timeline({
                        defaults: {
                                duration: 0.5,
                                ease: "power2.out",
                        },
                });
                menuTl
                        .to(" .mobileoverlay", {
                                scale: 1,

                                onComplete: function() {
                                        gsap.set(menuNav, {
                                                display: "flex",
                                        });
                                        gsap.set(".downloadbtn", {
                                                display: "flex",
                                        });
                                }
                        })
                        .fromTo(menuItem, {
                                yPercent: 100,
                        },{
                                yPercent: 0,
                                stagger: 0.1,
                                opacity: 1
                        })
                        .fromTo(".downloadbtn", {
                                yPercent: 200,
                                opacity: 0
                        },{
                                yPercent: 0,
                                opacity: 1
                        }, "<=.1")

                menuTl.paused(true);

                const menuText = btnMenu.dataset.menuText;
                const closeText = btnMenu.dataset.closeText;

                btnMenu.addEventListener('click', () => {
                        btnMenu.textContent = btnMenu.textContent.trim() === menuText ? closeText : menuText;
                        btnMenu.classList.toggle('is-active');
                        body.classList.toggle('noscroll');
                        if (!menuStatus) {
                                menuTl.play();
                                menuStatus = true;
                        } else {
                                menuTl.reverse();
                                menuStatus = false;
                        }
                })






        }
});


window.$ = $;
window.jQuery = $;
window.gsap = gsap;
